import { useState } from 'react';
import { User } from '../../components/client-panel/components/my-account-info/models/user.model';
import { UserSelection } from '../../components/client-panel/components/my-account-info/models/user-selection.model';

export const UserDetailsUseBetween = () => {
    const [userDetails, setUserDetails] = useState<User>();
    const [userSelection, setUserSelection] = useState<UserSelection>();
    const [isLoadingUserDetails, setIsLoadingUserDetails] = useState<boolean>(false);
    return {
        userDetails,
        setUserDetails,
        isLoadingUserDetails,
        setIsLoadingUserDetails,
        userSelection,
        setUserSelection,
    };
};
